import { styled, Theme } from '@mui/material/styles';

type ColorStatus = 'waiting-for-payment' | 'paid' | 'price-clarification';

const getColorStatus = (color: ColorStatus, theme: Theme) => {
  switch (color) {
    case 'waiting-for-payment':
      return theme.palette.warning.light;
    case 'price-clarification':
      return theme.palette.error.light;
    case 'paid':
      return theme.palette.success.light;
    default:
      return theme.palette.error.main;
  }
};

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '24px'
}));

export const StyledStatus = styled('div')(({ theme, color }) => ({
  width: '20%',
  textAlign: 'center',
  fontSize: '14px',
  paddingRight: '24px',
  color: getColorStatus(color as ColorStatus, theme)
}));

export const StyledOffers = styled('div')(() => ({
  width: '80%',
  paddingLeft: '12px',
  paddingRight: '96px',
  '& input': {
    textAlign: 'right'
  }
}));

export const StyledOffer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '16px'
}));

export const StyledPrice = styled('div')(() => ({

}));

export const StyledPriceRange = styled('span')(() => ({
  display: 'inline-block',
  '&::first-letter': {
    textTransform: 'capitalize'
  }
}));

export const StyledText = styled('span')(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.primary,
  fontSize: '10px',
  textAlign: 'center',
  paddingTop: '12px'
}));
